export default __webpack_public_path__ + "static/media/inviteSignup2.9902dc08.svg";